<div class="container-fluid pt-5 pb-5">
    <div class="d-flex flex-row bd-highlight"> 
      <div class="pt-5 col-xl-4 col-lg-6 col-md-8 col-sm-10 mx-xl-auto mx-lg-auto mx-md-auto mx-sm-auto content-main">
        <div class="card mx-auto border-0 shadow-lg rounded">
            <img [src]="coverPhoto" class="card-img-top img-cover" alt="...">
            <div class="p-2 mb-3">
              <h2 class="mb-3">Sign Up Form</h2>
              <p>It's Free & Easy. Create New Account.</p>
              <form [formGroup]="signupForm" (ngSubmit)="addPeopleForm()">          
                <input type="text" [formControlName]="'nameFirst'" placeholder="First Name"/>
                <input type="text" [formControlName]="'nameLast'" placeholder="Last Name"/>
                <input type="email" [formControlName]="'email'" placeholder="Email"/>
                <input type="password" [formControlName]="'password'" placeholder="Password"/>
                <button type="submit" class="btn btn-primary btn-block">Create New Account</button>               
              </form>
              <div class="alert alert-light text-center" role="alert">
                ------------- Or -----------------
              </div>
              <button type="submit" class="btn btn-color-g btn-block my-3">Register with Google</button>
              <button type="submit" class="btn btn-color-fb btn-block my-3">Register with Facebook</button>
              <h3 class="mt-3">Already have an account?</h3>
              <button class="btn btn-dark btn-block" (click)="routeToPeopleLoginPage()">Log In</button>        
            </div>
        </div>
      </div>
    </div>
  </div>